import { render, staticRenderFns } from "./LifeSysChartSoh.vue?vue&type=template&id=18962d64&"
import script from "./LifeSysChartSoh.vue?vue&type=script&lang=js&"
export * from "./LifeSysChartSoh.vue?vue&type=script&lang=js&"
import style0 from "./LifeSysChartSoh.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports